/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

export enum SaveAssetType {
  Asset = 0,
  AddAssetToAsset = 3,
}
